var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellStatusCritical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 12.7852C9.82693 12.7852 9.65776 12.8291 9.51387 12.9116C9.36998 12.994 9.25783 13.1111 9.1916 13.2481C9.12538 13.3852 9.10805 13.536 9.14181 13.6815C9.17557 13.827 9.25891 13.9606 9.38128 14.0655C9.50364 14.1704 9.65955 14.2418 9.82928 14.2707C9.99901 14.2997 10.1749 14.2848 10.3348 14.2281C10.4947 14.1713 10.6314 14.0752 10.7275 13.9518C10.8236 13.8285 10.875 13.6835 10.875 13.5352C10.875 13.3362 10.7828 13.1455 10.6187 13.0048C10.4546 12.8642 10.232 12.7852 9.99998 12.7852Z",
    fill: "#DB0046"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.0948V7.78516",
    stroke: "#DB0046",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0085 4.53855C10.9159 4.37695 10.7724 4.24084 10.5941 4.14565C10.4158 4.05046 10.21 4 9.99993 4C9.78989 4 9.58406 4.05046 9.40578 4.14565C9.22751 4.24084 9.08392 4.37695 8.99132 4.53855L3.09707 14.8309C3.02612 14.9546 2.99312 15.0918 3.00119 15.2295C3.00926 15.3672 3.05813 15.5008 3.14319 15.6178C3.22826 15.7348 3.3467 15.8313 3.48734 15.8982C3.62798 15.965 3.78619 16.0001 3.94702 16H16.0528C16.2137 16.0001 16.3719 15.965 16.5125 15.8982C16.6532 15.8313 16.7716 15.7348 16.8567 15.6178C16.9417 15.5008 16.9906 15.3672 16.9987 15.2295C17.0067 15.0918 16.9737 14.9546 16.9028 14.8309L11.0085 4.53855Z",
    stroke: "#DB0046",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellStatusCritical);
export default __webpack_public_path__ + "static/media/icn_table_cell_Status_Critical.85e5580a4f4d7b56bd4654b6a85b5cb1.svg";
export { ForwardRef as ReactComponent };